import Modal from '@components/App/Modal/Modal'
import NotificationWrapper from '@components/App/NotificationContainer/NotificationWrapper'
import SystemDialogs from '@components/App/SystemDialogs'
import { DashboardLayout, SubscriptionContent } from '@components/Dashboard'
import type React from 'react'

import { AuthenticatedWrapper } from './AuthenticatedWrapper'

export const Subscription: React.FC = () => (
  <AuthenticatedWrapper>
    <NotificationWrapper />
    <DashboardLayout>
      <SubscriptionContent />
    </DashboardLayout>
    <SystemDialogs />
    <Modal />
  </AuthenticatedWrapper>
)
